import { uiTokens } from '@/theme/uiTokens';
import type { CountSegment } from './cells/StackedCountBar';

type ExecutionStatusCounts = {
  passed?: number | null;
  failed?: number | null;
  errored?: number | null;
  skipped?: number | null;
  untested?: number | null;
};

const toCount = (value: number | null | undefined): number =>
  typeof value === 'number' ? value : 0;

export const buildExecutionStatusSegments = (counts: ExecutionStatusCounts): CountSegment[] => [
  { label: 'Passed', value: toCount(counts.passed), color: uiTokens.statusColors.green },
  { label: 'Failed', value: toCount(counts.failed), color: uiTokens.statusColors.red },
  { label: 'Errored', value: toCount(counts.errored), color: uiTokens.statusColors.brown },
  { label: 'Skipped', value: toCount(counts.skipped), color: uiTokens.statusColors.orange },
  { label: 'Untested', value: toCount(counts.untested), color: uiTokens.statusColors.neutral },
];

export const sumExecutionStatusCounts = (counts: ExecutionStatusCounts): number => {
  return (
    toCount(counts.passed) +
    toCount(counts.failed) +
    toCount(counts.errored) +
    toCount(counts.skipped) +
    toCount(counts.untested)
  );
};
